// extracted by mini-css-extract-plugin
module.exports = {"body":"style__body__a6SVg","dropArea":"style__dropArea__RbAKK","active":"style__active__Opvhs"};